export enum POSSource {
    UNTILL = 'UnTill',
}
